/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxMlYxMS4yMjEySDEyVjEySDJaTTIgOS42OTc5NFY4LjkxOTE3SDEyVjkuNjk3OTRIMlpNMiA3LjM4Nzc2VjYuNjA4OTlIMTJWNy4zODc3NkgyWk0yIDUuMDg1N1Y0LjMwNjkzSDEyVjUuMDg1N0gyWk0yIDIuNzc4NzdWMkgxMlYyLjc3ODc3SDJaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";